import React from "react";
import { Grid, GridItem } from "@chakra-ui/react";
import FormFeature from "./form/formFeature";
import { ROLES_CONFIG } from "../../../utils";
import { useSelector } from "react-redux";
import { useProjectCategoriesCustomerType } from "../../../hooks/useProjectCategoriesCustomer";

const Project = () => {
  const {
    customerType,
    refetch,
    isLoading,
    isRefetching,
  } = useProjectCategoriesCustomerType();

  const user = useSelector((state) => state.auth.login?.currentUser);
  const roles = user?.roles || [];

  const hasPermission = (requiredRoles = []) => { 
  
    if (!Array.isArray(requiredRoles)) {
      return false;
    }
  
    if (!Array.isArray(roles)) {
      return false;
    }
  
    return (
      requiredRoles.some((role) => roles.includes(role)) ||
      roles.includes("ALL")
    );
  };
  

  const gridItemsData = [
    {
      title: "Danh sách loại khách hàng",
      button: "Loại khách hàng",
      data: {
        headers: [
          { label: "", key: "" },
          { label: "STT", key: "" },
          { label: "Tên loại khách hàng", key: "name" },
        ],
        data: customerType,
        role: ROLES_CONFIG.MENU.MENU_QLDM.CHILDREN.CHILDREN_DA.TAB.TAB_KH
            .CHILDREN_TAB.CHILDREN_CUSTOMER_TYPE.role
      },
      type: 0,
      textDelete: "loại khách hàng",
      textAdd: "Tạo loại khách hàng mới",
      textButtonAdd: "Tạo loại khách hàng mới",
      textTitleEdit: "Chỉnh sửa loại khách hàng",
    },
  ];

  return (
    <Grid minH={"80vh"} templateColumns="repeat(1, 1fr)" gap={4}>
      {gridItemsData.map(
        (item, index) =>
          hasPermission(item.data.role) && (
            <GridItem
              key={index}
              p={"16px"}
              bg={"var(--color-main)"}
              borderRadius={"16px"}
            >
              <FormFeature
                title={item.title}
                button={item.button}
                data={item.data}
                isLoading={isLoading}
                isRefetching={isRefetching}
                refetch={refetch}
                dataSelect={item?.dataSelect || null}
                type={item.type}
                textDelete={item?.textDelete || null}
                textAdd={item?.textAdd || null}
                textButtonAdd={item?.textButtonAdd || null}
                textTitleEdit={item?.textTitleEdit || null}
                formTable={false}
              />
            </GridItem>
          )
      )}
    </Grid>
  );
};

export default Project;
